"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var castDateToISO = function (date) {
    var year = date.getFullYear();
    var month = (0, helpers_1.zeroify)(date.getMonth() + 1);
    var day = (0, helpers_1.zeroify)(date.getDate());
    return "".concat(year, "-").concat(month, "-").concat(day);
};
exports.default = castDateToISO;
